var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-more-radius btn-outline-primary",on:{"click":function($event){return _vm.readCurrencyValue()}}},[_vm._v("\n    Dolar Kuru : "+_vm._s(_vm.parityValue)+"\n  ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-center"},[_vm._v(_vm._s(_vm.parityDate))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18792bf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tool/CurrencyParity.vue
// module id = null
// module chunks = 